import React from "react";
import './Contact.css';
import contactPic  from '../../assets/img/contact-image.jpg';
import { Button } from '@chakra-ui/react'
import { PopupModal  } from "react-calendly";
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default class Contact extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	render() {
		return (
		<div id="contact" className="contact-container">
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeDown" animateOnce={true} delay={0}>
				<div className="section-briefing">
					<h1 className="section-title">LET'S CHAT</h1>
					<div className="briefing-text">
					</div>
				</div>
			</AnimationOnScroll>
			<AnimationOnScroll initiallyVisible={false} animateIn="fadeUp" animateOnce={true} delay={0}>
				<div className="section-showcase blue-gradient">
					<AnimationOnScroll initiallyVisible={false} animateIn="fadeInAnimation" animateOnce={true} delay={300}>
						<div className="chat-wrapper">
							<div className="chat-picture fade-to-black">
								<img src={contactPic} alt="" />
							</div>
							<div className="chat-text">
								<div>
									<p className="item-subhead">HI THERE</p>
									<p className="item-body">Interested in exploring ways to boost your brand with Web3? Send us a message or schedule a call and let us know how we can help.</p>
								</div>
								<div>
									<Button variant='outlineBlueAnimated' onClick={()=>{this.setState({isOpen:true})}}>
										LET'S CHAT!
									</Button>
								</div>
							</div>
						</div>
					</AnimationOnScroll>
				</div>
			</AnimationOnScroll>
			<PopupModal
				url="https://calendly.com/kinetic-chain/intro"
				onModalClose={() => this.setState({ isOpen: false })}
				open={this.state.isOpen}
				/*
				* react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
				* specify the rootElement property to ensure that the modal is inserted into the correct domNode.
				*/
				rootElement={document.getElementById("root")}
			/>
		</div>
		);
	}
}
